import { Box } from '@material-ui/core';
import { DnsOutlined, ImageOutlined, PeopleAltOutlined, WorkOutlineOutlined } from '@material-ui/icons';
import { MainContent, MainSideMenu, Menus } from '@swyft/ui';
import { ReactElement } from 'react';
import { Layout, LayoutProps } from '../models';
import { MainNavMenu } from './MainNavMenu';

const items: Menus = [
  {
    path: '/clients',
    title: `Clients`,
    icon: WorkOutlineOutlined
  },
  {
    path: '/users',
    title: `Users`,
    icon: PeopleAltOutlined
  },
  {
    path: '/engineers',
    title: `Engineers`,
    icon: PeopleAltOutlined
  },
  {
    path: '/services',
    title: `Services`,
    icon: DnsOutlined
  },
  {
    path: '/gallery',
    title: `Gallery`,
    icon: ImageOutlined,
    source: `Resources`
  },
  {
    path: '/swyft',
    title: `Swyft`,
    icon: ImageOutlined,
    source: `Swyft`
  }
];

export const MainLayout: Layout = ({ children }: LayoutProps): ReactElement => (
  <div className='flex w-full h-full overflow-hidden'>
    <MainNavMenu />
    <MainSideMenu items={items} />
    <MainContent>
      <Box mx='auto' display={'flex'} flexDirection={'column'} height={'100%'}>
        {children}
      </Box>
    </MainContent>
  </div>
);
